import { useMemo } from "react";

import { useCurrentUser } from "@/features/auth";
import { IRecommendationsCategorySelection } from "@/stores/recommendationsCategorySelection";

/**
 * Default recommendation types when organization doesn't have configured types
 */
const DEFAULT_RECOMMENDATION_TYPES: readonly IRecommendationsCategorySelection[] =
  [
    { type: "roster", label: "Roster Upgrades" },
    { type: "transfer_targets", label: "Transfer Targets" },
  ] as const;

/**
 * Hook to get recommendation types for the current user's organization
 * @returns Recommendation types and default type
 */
export const useRecommendationTypes = () => {
  const currentUser = useCurrentUser();

  const recommendationTypes = useMemo<
    IRecommendationsCategorySelection[]
  >(() => {
    const orgTypes = currentUser?.organization?.recommendationTypes ?? [];
    const mappedTypes = orgTypes.map(({ type, label }) => ({
      type,
      label,
    }));
    return mappedTypes.length > 0
      ? mappedTypes
      : [...DEFAULT_RECOMMENDATION_TYPES];
  }, [currentUser?.organization?.recommendationTypes]);

  const defaultRecommendationType = useMemo(
    () => recommendationTypes[0]?.type,
    [recommendationTypes]
  );

  return {
    recommendationTypes,
    defaultRecommendationType,
  };
};
